import { render, staticRenderFns } from "./TrademarkSearchSuccessRate.vue?vue&type=template&id=6b9ba67b&"
import script from "./TrademarkSearchSuccessRate.vue?vue&type=script&lang=js&"
export * from "./TrademarkSearchSuccessRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports